import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { makeUserNameSelector } from "~/store/selectors/selector.users.jsx";

export const useAssigneeTitle = (assigneeId, fakeAssigneeName) => {
  const { t } = useTranslation();

  const getName = useMemo(() => makeUserNameSelector(), []);
  const name = useSelector((state) => getName(state, assigneeId));

  if (name) {
    return name;
  }

  if (fakeAssigneeName?.length) {
    return fakeAssigneeName;
  }

  return t("Assign");
};
